import Request from "./request";
import $ from "jquery";
import {twitterGet} from "api";

export default function ($app) {
	const self = this;
	const $ui = $app.require('ui');
	const $locale = $app.require('locale');
	let timer = null;
	const timeout = parseInt($app.event().moduleTwitter.timeout()) || 60;
	const messages = ko.observableArray();
	const lastId = ko.observable(0);

	self.title = ko.observable($locale.get('twitter.title'));
	self.name = 'twitter';
	self.position = ko.computed(function() { return $app.event().moduleTwitter.position(); });
	self.isEnabled = ko.computed(function() {
		return !$app.episode() && $app.event().moduleTwitter.enabled() && !(Request.params['hideFooter'] && self.position() == 'bottom');
	});

	self.messages = ko.computed(function() {
		return messages();
	});

	self.init = function() {
		self.loadMessages();
	};

	self.loadMessages = function() {
		twitterGet($app.event().eventKey(), {sinceId: lastId()})
			.then((data) => {
				if(data instanceof Array) {
					data.forEach(function(message) {
						if(lastId() < message.id) {
							lastId(message.id);
						}
						messages.push({
							id: message.id,
							time: message.time,
							nickname: message.nickname,
							link: '//twitter.com/' + message.user.screen_name,
							avatar: message.user.avatar_https,
							text: message.text,
							html: $('<div>').text(message.text).html()
								.replace(/((https|http|ftp|ssl|mailto):\/\/[^\s<]+)/gi, '<a href="$1" target="_blank">$1</a>')
								.replace(/(^|\s)#([_0-9A-Zа-я]+)/ig, '$1<a target="_blank" href="http://twitter.com/search?q=%23$2">#$2</a>')
								.replace(/(^|\s)@([_0-9A-Zа-я]+)/ig, '$1<a target="_blank" href="http://twitter.com/search?q=%40$2">@$2</a>')
						});
					});
				}
			})
			.finally(function() {
				timer = setTimeout(function() { self.loadMessages(); }, timeout * 1000);
			})
		;
	};

	self.remove = function() {
		clearTimeout(timer);
	};

	$app.on('start', function() {
		if(self.isEnabled()) {
			self.uiTab = new $ui.Tab(self);
			setTimeout(() => self.init(), 0);
		}
	});
}
